import React, { useEffect, useState } from "react";
import { Link, useNavigate,useLocation } from "react-router-dom";
import colors from "../Constants/colors";
import { FaChalkboard } from "react-icons/fa";
import axios from "axios";
  const getTeacherNameFromStorage = () => {
  try {
    const teacher = JSON.parse(localStorage.getItem("teacher"));
    return teacher?.firstName || "Teacher";
  } catch {
    return "Teacher";
  }
};
const Navbar = ({ toggleSidebar }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [notificationCount, setNotificationCount] = useState(0);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
 const [teacherName, setTeacherName] = useState(getTeacherNameFromStorage);


  const teacherRole = "Teacher";
 const routeTitles = {
    "/profile-management": "Profile Management",
    "/homework":"Homework",
     "/test-schedule":"Test Schedule",
      "/add-notification":"Add Notification",
       "/user-password":"Usernames & Passwords",
        "/class-reports":"Class Reports",
         "/student-attendance":"Student Attandance",
          "/view-attendance":"Attandance",
           "/my-schedule":"Schedule",
            "/courses-management":"Courses",
             "/course-materials":"Course Materials",
              "/assignments":"Assignements",
               "/examination-management":"Exam Management",
                "/prepare-result":"Result",
                 "/old-papers":"Old Papers", "/salary-management":"Attandance",
                  "/fee-management":"Fee Managemnet",
                  "/fee-report":"Fee Report",
                  "/notification-management":"Notifiaction Management",
                  "/view-notification":"View Notification",
                  "/student-achievements":"Student Achievements","/dashboard":"Dashboard",
                  "":"","":"",
                  "":"",
  };
  const pageTitle = routeTitles[location.pathname] || "";


  // Close dropdown if clicked outside
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (!e.target.closest(".profile-dropdown")) {
        setIsDropdownOpen(false);
      }
    };
    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, []);

  // Load notifications
  useEffect(() => {
    const loadNotifications = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_BASE_URL}/api/notifications/getNotification`
        );
        const data = await response.json();
        setNotificationCount(data?.length || 0);
      } catch (error) {
        console.error("Error fetching notifications:", error);
      }
    };
    loadNotifications();
  }, []);

  // Load teacher profile
useEffect(() => {
  const teacher = JSON.parse(localStorage.getItem("teacher"));
  const sessionId = localStorage.getItem("currentSessionId");

  if (!teacher?.id || !sessionId) {
    setTeacherName("Teacher");
    return;
  }

  const loadTeacherProfile = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/api/teachers/getTeacherById/${teacher.id}/${sessionId}`
      );

      const name = response.data?.firstName || "Teacher";
      setTeacherName(name);

      // keep teacher object in sync
      localStorage.setItem(
        "teacher",
        JSON.stringify({ ...teacher, firstName: name })
      );

    } catch (error) {
      console.error("Error loading teacher profile:", error);
      setTeacherName(getTeacherNameFromStorage());
    }
  };

  loadTeacherProfile();
}, []);



  const handleLogout = () => {
      localStorage.clear();
       sessionStorage.clear();
    navigate("/login");
    window.location.reload();
  };

  const handleNotificationClick = () => setNotificationCount(0);

  return (
    <nav
      className="p-4 flex justify-between items-center shadow-lg flex-wrap md:flex-nowrap"
      style={{
        background: colors.gradientPrimary,
        color: colors.primaryText,
      }}
    >
      {/* LEFT SECTION — Teacher Panel */}
      <div className="flex items-center space-x-2 flex-shrink-0">
        <FaChalkboard className="text-white h-6 w-6 md:h-7 md:w-7" />
        <h2 className="text-lg md:text-xl font-bold text-white whitespace-nowrap">
          Teacher Panel
        </h2>
      </div>
     <div className="hidden md:flex absolute left-1/2 transform -translate-x-1/2">
        <h1 className="text-white text-xl font-semibold truncate max-w-xs text-center">
          {pageTitle}
        </h1>
      </div>
      {/* RIGHT SECTION */}
      <div className="flex items-center space-x-4 md:space-x-6 mt-2 md:mt-0">
        {/* Notifications */}
        <Link
          to="/view-notification"
          className="relative text-white"
          onClick={handleNotificationClick}
        >
          <i className="fas fa-bell text-2xl hover:text-yellow-300 transition relative">
            {notificationCount > 0 && (
              <div className="absolute -top-2 -right-2 w-5 h-5 bg-red-600 text-white text-xs font-bold flex items-center justify-center rounded-full shadow-lg">
                {notificationCount}
              </div>
            )}
          </i>
        </Link>

        {/* Profile Dropdown */}
        <div className="relative profile-dropdown">
          <div
            className="flex items-center space-x-2 cursor-pointer"
            onClick={() => setIsDropdownOpen(!isDropdownOpen)}
          >
            <i className="fas fa-user-circle text-3xl md:text-4xl text-white"></i>
            <div className="flex flex-col text-white leading-tight hidden sm:flex">
              <span className="text-xs font-semibold truncate">
                Welcome, {teacherName}
              </span>
              <span className="text-xs opacity-80">{teacherRole}</span>
            </div>
          </div>

          {isDropdownOpen && (
            <div className="absolute right-0 mt-1 w-36 bg-white shadow-lg rounded-md py-2 z-50">
              <Link
                to="/view-profile"
                className="block text-sm px-3 py-1 text-black hover:bg-gray-100"
                onClick={() => setIsDropdownOpen(false)}
              >
                View Profile
              </Link>
              <button
                onClick={() => {
                  setIsDropdownOpen(false);
                  handleLogout();
                }}
                className="block text-sm w-full text-left px-3 py-1 text-black hover:bg-gray-100"
              >
                Logout
              </button>
            </div>
          )}
        </div>

        {/* Mobile Hamburger */}
        <button
          onClick={toggleSidebar}
          className="text-white md:hidden ml-2 focus:outline-none"
        >
          <i className="fas fa-bars text-3xl"></i>
        </button>
      </div>
    </nav>
  );
};

export default Navbar;
